import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { UserProvider } from './contexts/user';
import { AssessmentsProvider } from './contexts/assessments';
import { GroupProvider } from './contexts/group';
import { ReportAccessProvider } from './contexts/reportAccess';
import { Buffer } from "buffer";

if (!window.Buffer) {
  window.Buffer = Buffer;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  palette:{
    primary:{
      main:"#69AF45"
    } ,
    secondary:{
      main:"#0F5385",
    },
    lightBlueCustom:{
      main:"#E8F6F8"
    },
    blueCustom:{
      main:"#2B8DCC",
    },
    darkGreenCustom:{
      main:"#519342",
    },
    lightGreenCustom:{
      main:"#6AAF44"
    }
  },
  typography:{
    fontFamily:['Tahoma','Nunito','Helvetica Neue','Arial','Helvetica'].join(',')
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          // Color del borde al enfocarse (el primary de MUI es el azul por defecto)
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#69AF45', // ¡Rojo para todos los inputs al enfocarse!
          },
          // Color del borde inactivo
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#69AF45',
          },
        },
      },
    },
  },
})

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <UserProvider>
        <AssessmentsProvider>
          <GroupProvider>
            <ReportAccessProvider>
              <ThemeProvider theme={theme}>
                <App/>
              </ThemeProvider>
            </ReportAccessProvider>
          </GroupProvider>
        </AssessmentsProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
